import { useEffect, useState, VFC } from "react";
import { LoginAsDialog } from "../../../../components/auth/login-as-dialog.component";
import { IGroup } from "../../../../domain/group/group";
import { IPaginationInputMeta } from "../../../../domain/pagination/pagination-meta";
import { IUser, IUserLoginAs } from "../../../../domain/user/user";
import { useGetGroupUsers } from "../../../../repositories/queries/user/get-group-users.query";
import { UserDetailDialog } from "../dialogues/user-detail-dialog.component";
import { GroupDetailsUsersBaseTable } from "./group-detail-users-base-table.component";

interface IGroupDetailsUsersTableProps {
  group: IGroup;
}

export const GroupDetailsUsersTable: VFC<IGroupDetailsUsersTableProps> = (props) => {
  const { group } = props;
  const [paginationInputMeta, setPaginationInputMeta] = useState<IPaginationInputMeta>({
    page: 0,
    pageSize: 5,
  });
  const [selectedUser, setSelectedUser] = useState<IUser | undefined>();
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isLoginAsOpen, setIsLoginAsOpen] = useState(false);

  const { isLoading, data: userResult, refetch } = useGetGroupUsers(group.erpNumber, paginationInputMeta);

  useEffect(() => {
    refetch();
  }, [paginationInputMeta.page, refetch]);

  const handleRowClicked = (user: IUser | undefined) => {
    setSelectedUser(user);
    setIsDetailOpen(true);
  };

  const loginAsUser: IUserLoginAs | undefined = selectedUser
    ? { firstName: selectedUser.firstName, lastName: selectedUser.lastName, username: selectedUser.username }
    : undefined;

  return (
    <>
      <LoginAsDialog
        user={loginAsUser}
        open={isLoginAsOpen}
        onCancel={() => {
          setIsDetailOpen(false);
          setIsLoginAsOpen(false);
        }}
      />

      <UserDetailDialog
        open={isDetailOpen}
        user={selectedUser}
        onClose={() => {
          setIsDetailOpen(false);
        }}
        onLoginAsClick={() => {
          setIsLoginAsOpen(true);
          setIsDetailOpen(false);
        }}
      />

      <GroupDetailsUsersBaseTable
        userResult={userResult}
        onRowClicked={handleRowClicked}
        isLoading={isLoading}
        paginationInputMeta={paginationInputMeta}
        setPaginationInputMeta={setPaginationInputMeta}
      />
    </>
  );
};
